// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardFrontendLisenses_wrapper__a7hbg","header":"DashboardFrontendLisenses_header__JC5gq"};